import React, { ChangeEvent } from "react";
import { DebounceInput } from "react-debounce-input";
import { CiSearch } from "react-icons/ci";

interface SearchInputProps {
  debounceTimeout?: number;
  placeholder?: string;
  className?: string;
  label?: string;
  extraLabel?: string;
  onChange: (searchTerm: string) => void;
  value?: string;
  error?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
  debounceTimeout = 300,
  placeholder = "Search...",
  className = "",
  label = "Search",
  extraLabel = "",
  onChange,
  value,
  error = false,
}) => {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div
      className={`text-left  w-full mx-auto sm:w-[80%] md:w-[70%] lg:w-[50%] ${className}`}
    >
      <h6 className="font-Mulish text-base text-lightBlue mb-1 truncate overflow-hidden whitespace-nowrap">
        {label}
        <span className="text-red-500">*</span>{" "}
        {extraLabel && (
          <span className="text-primary font-Mulish text-base">
            {extraLabel}
          </span>
        )}
      </h6>
      <div
        className={`relative border-2  ${
          error ? "border-red-500" : "border-[#EAECF0]"
        }   rounded-[10px]  flex items-center  h-[60px] sm:h-[60px]`}
      >
        <div className="flex items-center pl-3 pointer-events-none">
          <CiSearch className="text-[25px] text-gray-400" />
        </div>
        <DebounceInput
          type="text"
          value={value}
          onChange={handleSearchChange}
          debounceTimeout={debounceTimeout}
          className={`font-Mulish text-base text-darkgrey px-4 py-1 sm:py-2 focus:outline-none focus:none w-full`}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default SearchInput;
